export const getApiUrl = () => {
  const baseURL = import.meta.env.BASE_URL + 'api';

  return baseURL;
};

export const centralAuthUrl = import.meta.env.VITE_CENTRAL_AUTH_AUTH_URL;

export const clientAuthRealm = import.meta.env.VITE_CLIENT_REALM;

export const centralAuthRealm = import.meta.env.VITE_CENTRAL_AUTH_CLIENT_REALM;

export const isEnableAccountSwitcher = false;

const env: string = import.meta.env.VITE_ENV || '';
export const isLocal = env.toLowerCase() === 'local';

export const contactSupportMail = import.meta.env.VITE_CONTACT_SUPPORT_EMAIL;
